module.exports = require("@swa-ui/dotcom/src/DesktopHeaderControl/AnonymousInformation.module.scss");